import React from 'react';
import styled from 'styled-components';
import { Form, Formik, FormikHelpers } from 'formik';

// components
import { TextField } from 'components/formik/TextField';
// style
import { Gap } from '../layout';
// assets
import { MdSend } from 'react-icons/md';
// context
import { useSockets } from 'context/socket/SocketProvider';
// queries
import { useSendConversationMessage } from 'queries/conversations/sendConversationMutation';

const FormStyles = styled(Form)`
  align-items: center;
  display: flex;
  height: 72px;
  width: 100%;
`;

const SubmitBtn = styled.button`
  display: flex;
  cursor: pointer;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  gap: 10px;

  width: 40px;
  height: 38px;

  background: #09534a;

  border-radius: 5px;
  border: none;
  :disabled {
    opacity: 0.3;
  }
`;

interface ISendConversationMessage {
  message: string;
  userId: string;
}

interface ILiveChat {
  scrollToBottom: () => void;
  userId: number;
  setUnread: React.Dispatch<React.SetStateAction<boolean>>;
}

export const LiveChatForm = ({
  scrollToBottom,
  userId,
  setUnread,
}: ILiveChat) => {
  const { currentConversation } = useSockets();
  const conversationId = currentConversation?.conversationId;
  const { mutate: sendMessageMutation } = useSendConversationMessage();

  const onSubmitHandler = async (
    values: ISendConversationMessage,
    formikHelpers: FormikHelpers<ISendConversationMessage>
  ) => {
    if (!conversationId) {
      return;
    }
    sendMessageMutation({
      conversationId,
      data: { message: values.message },
      formikHelpers,
    });
    scrollToBottom();
  };

  return (
    <Formik
      initialValues={{
        message: '',
        userId: `${userId}`,
      }}
      onSubmit={onSubmitHandler}
    >
      {({ values, isSubmitting }) => (
        <FormStyles>
          <Gap direction='row' style={{ width: '100%' }}>
            <TextField
              onFocus={() => setUnread(false)}
              name='message'
              type='text'
              placeholder='Write a message...'
            />
            <SubmitBtn
              disabled={!values?.message?.length || isSubmitting}
              type='submit'
            >
              <MdSend color='white' size={20} />
            </SubmitBtn>
          </Gap>
        </FormStyles>
      )}
    </Formik>
  );
};
